'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["FieldSelectItemComponent", "activeGroup", "activeFieldNames", "className", "currencyCode", "editorSubtitle", "fieldGroups", "fields", "filterFamily", "getDefaultTimezone", "getDescriptionString", "getFamilyValueResolver", "getFilterFamilyName", "getFilterFamilyOptions", "getInputComponent", "getIsUngated", "getLabelString", "getOperatorLabel", "getOperators", "getPlaceholder", "getReferencedObjectType", "getFilterFamilyObjectName", "getSpecialOptionsForReferenceType", "getObjectPropertyLabel", "isFieldDescriptionVisible", "isFiscalYearEnabled", "isInitialStepBackButtonDisabled", "isRollingDateOffsetInputEnabled", "isXoEnabled", "labelOperatorCreateSave", "loadMoreFields", "onChange", "onChangeFilterFamily", "onDone", "renderFieldLink", "searchable", "showIncludeUnknownValues", "style", "nullIssueRelatedState", "updateNullIssueRelatedState"];
import { Map as ImmutableMap, OrderedSet, Set as ImmutableSet } from 'immutable';
import { isValidOperator } from '../../filterQueryFormat/operator/Operator';
import { mapOf, setOf } from 'react-immutable-proptypes';
import FilterEditorFieldSelect from './FilterEditorFieldSelect';
import FilterEditorPanel from './FilterEditorPanel';
import FilterFamilySelect from '../FilterFamilySelect';
import FilterEditorEntitySelect from './FilterEditorEntitySelect';
import FilterFieldGroupType from '../../components/propTypes/FilterFieldGroupType';
import FilterFieldType from '../../components/propTypes/FilterFieldType';
import FilterOperatorErrorRecord from '../../filterQueryFormat/FilterOperatorErrorRecord';
import FilterOperatorRefinableInput from '../operator/FilterOperatorRefinableInput';
import FilterOperatorType from '../../components/propTypes/FilterOperatorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import getIn from 'transmute/getIn';
import isRecord from 'transmute/isRecord';
import NullRelatedState from '../propTypes/NullRelatedState';
import always from 'transmute/always';
import FilterType from '../propTypes/FilterType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class FilterEditorOperatorCreate extends Component {
  constructor(props) {
    super(props);
    this.handleGoBack = () => {
      const {
        fields,
        getFilterFamilyOptions,
        isXoEnabled,
        onChangeFilterFamily,
        onDone,
        onChange
      } = this.props;
      const {
        didInitializeWithAFilterFamily,
        didSelectFilterFamily,
        didSelectEntity,
        entityParentFilterFamily
      } = this.state;
      const value = this.getValue();
      const filterFamilyOptionCount = getFilterFamilyOptions().size || 0;
      const fieldCount = ImmutableMap.isMap(fields) ? fields.size : 0;
      const nextState = {
        error: FilterOperatorErrorRecord({
          error: false
        })
      };
      if (value && fieldCount !== 1) {
        nextState.draft = null;
        onChange(syntheticEvent(null));
      } else if (isXoEnabled && filterFamilyOptionCount > 1 && didSelectFilterFamily && didSelectEntity && !didInitializeWithAFilterFamily) {
        nextState.didSelectEntity = false;
        nextState.entity = undefined;
        nextState.searchValue = '';
        onChangeFilterFamily(syntheticEvent(entityParentFilterFamily));
        if (fieldCount === 1) {
          nextState.draft = null;
          onChange(syntheticEvent(null));
        }
      } else if (isXoEnabled && filterFamilyOptionCount > 1 && didSelectFilterFamily && !didInitializeWithAFilterFamily) {
        nextState.didSelectFilterFamily = false;
        nextState.searchValue = '';
        onChangeFilterFamily(syntheticEvent(undefined));
        if (fieldCount === 1) {
          nextState.draft = null;
          onChange(syntheticEvent(null));
        }
      } else if (isXoEnabled && filterFamilyOptionCount > 1) {
        nextState.searchValue = '';
        onChangeFilterFamily(syntheticEvent(undefined));
        onDone(syntheticEvent(null), true);
      } else {
        onDone(syntheticEvent(null), true);
      }
      this.setState(nextState);
    };
    this.handleChange = evt => {
      const {
        target: {
          value
        }
      } = evt;
      if (!isValidOperator(value)) {
        this.setState({
          draft: value,
          error: FilterOperatorErrorRecord({
            error: false
          })
        });
        return;
      }
      this.props.onChange(syntheticEvent(value));
      this.setState({
        draft: null,
        error: FilterOperatorErrorRecord({
          error: false
        })
      });
    };
    this.handleSearchChange = evt => {
      const {
        target: {
          value = ''
        }
      } = evt;
      const {
        onFieldSearchChange,
        filterFamily
      } = this.props;
      this.setState({
        searchValue: value
      });
      onFieldSearchChange(value, filterFamily);
    };
    this.handleSelectFilterFamily = evt => {
      const {
        target: {
          name: nextFilterFamily
        }
      } = evt;
      const {
        filterFamily,
        onChangeFilterFamily
      } = this.props;
      onChangeFilterFamily(syntheticEvent(nextFilterFamily));
      if (nextFilterFamily !== filterFamily) {
        this.setState({
          didSelectFilterFamily: true,
          searchScrollTop: 0
        });
      }
      this.setState({
        didSelectFilterFamily: true
      });
    };
    this.handleSelectEntity = evt => {
      const {
        target: {
          value: entity
        }
      } = evt;
      const {
        filterFamily,
        onChangeFilterFamily
      } = this.props;
      onChangeFilterFamily(syntheticEvent(entity.name));
      this.setState({
        didSelectEntity: true,
        entity: entity.name,
        entityParentFilterFamily: filterFamily
      });
    };
    this.handleSelectField = evt => {
      this.handleChange(evt);

      // TODO crabideau: the temp column needs to be removed!
      const {
        onTempColumnAdd
      } = this.props;
      if (typeof onTempColumnAdd === 'function') {
        onTempColumnAdd(evt.target.value);
      }
    };
    this.handleSubmit = evt => {
      evt.preventDefault();
      const {
        validateOperator
      } = this.props;
      const value = this.getValue();
      const validationError = validateOperator(value);
      const error = isRecord(validationError) ? validationError : FilterOperatorErrorRecord(validationError);
      const isError = error.get('error') || false;
      if (isValidOperator(value) && !isError) {
        this.props.onDone(syntheticEvent(value));
        this.setState({
          error: FilterOperatorErrorRecord({
            errorOpts: error.get('opts') || {}
          })
        });
      } else {
        this.setState({
          error
        });
      }
    };
    this.state = {
      didInitializeWithAFilterFamily: false,
      didSelectFilterFamily: Boolean(!props.isXoEnabled || props.filterFamily),
      didSelectEntity: false,
      draft: null,
      entity: undefined,
      entityParentFilterFamily: undefined,
      error: FilterOperatorErrorRecord({
        error: false
      }),
      searchScrollTop: 0,
      searchValue: ''
    };
  }
  componentDidMount() {
    this.focusTypeahead();
    if (this.props.filterFamily) {
      this.setState({
        didInitializeWithAFilterFamily: true
      });
    }
  }
  componentDidUpdate(_, prevState) {
    if (!this.state.draft && prevState.draft !== this.state.draft) {
      this.focusTypeahead();
    }
  }
  componentWillUnmount() {
    this.props.onFieldSearchChange('', null);
  }
  focusTypeahead() {
    const typeahead = this.refs.typeahead;
    if (typeahead) {
      typeahead.focus();
    }
  }
  getValue() {
    return this.state.draft || this.props.value;
  }
  getEditorTitle() {
    const {
      filterFamily,
      getFilterFamilyName,
      getLabelString,
      isXoEnabled
    } = this.props;
    const {
      didSelectFilterFamily
    } = this.state;
    const value = this.getValue();
    if (!didSelectFilterFamily) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterEditorOperatorCreate.filterTypeTitle"
      });
    } else if (didSelectFilterFamily && !value && isXoEnabled) {
      return getFilterFamilyName(filterFamily);
    } else if (didSelectFilterFamily && value) {
      return value && value.field && getLabelString(value.field);
    }
    return '';
  }
  isOnFamilySelect() {
    const {
      getFilterFamilyOptions
    } = this.props;
    const {
      didSelectFilterFamily
    } = this.state;
    const filterFamilyOptions = getFilterFamilyOptions();
    return !didSelectFilterFamily && filterFamilyOptions.size > 1;
  }
  isOnEntitySelect() {
    const {
      getFilterFamilyHasEntities,
      filterFamily
    } = this.props;
    const {
      didSelectEntity,
      didSelectFilterFamily
    } = this.state;
    const entityNeededForFilterFamily = getFilterFamilyHasEntities(filterFamily);
    return didSelectFilterFamily && !didSelectEntity && entityNeededForFilterFamily;
  }
  isOnFieldSelect() {
    const value = this.getValue();
    const {
      didSelectFilterFamily
    } = this.state;
    return didSelectFilterFamily && !value;
  }
  isOnOperatorSelect() {
    const value = this.getValue();
    return !!value;
  }
  render() {
    const _this$props = this.props,
      {
        FieldSelectItemComponent,
        activeGroup,
        activeFieldNames,
        className,
        currencyCode,
        editorSubtitle,
        fieldGroups,
        fields,
        filterFamily,
        getDefaultTimezone,
        getDescriptionString,
        getFamilyValueResolver,
        getFilterFamilyName,
        getFilterFamilyOptions,
        getInputComponent,
        getIsUngated,
        getLabelString,
        getOperatorLabel,
        getOperators,
        getPlaceholder,
        getReferencedObjectType,
        getFilterFamilyObjectName,
        getSpecialOptionsForReferenceType,
        getObjectPropertyLabel,
        isFieldDescriptionVisible,
        isFiscalYearEnabled,
        isInitialStepBackButtonDisabled,
        isRollingDateOffsetInputEnabled,
        isXoEnabled,
        labelOperatorCreateSave = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditorOperatorCreate.save"
        }),
        loadMoreFields,
        renderFieldLink,
        searchable,
        showIncludeUnknownValues,
        style,
        nullIssueRelatedState,
        updateNullIssueRelatedState
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      didSelectFilterFamily,
      error,
      searchValue
    } = this.state;
    const value = this.getValue();
    const isBodyHeightFixed = Boolean(didSelectFilterFamily && !value);
    const filterFamilyOptions = getFilterFamilyOptions();
    const filterFamilyOptionCount = getFilterFamilyOptions().size || 0;
    const isInitialStep = filterFamilyOptionCount > 1 ? !didSelectFilterFamily && !value : !value;
    const conditionsFieldNameDisplayBlocklist = ImmutableSet(['favoriteUserList']);
    const isNameBlocklisted = propertyRecord => !conditionsFieldNameDisplayBlocklist.contains(propertyRecord.get('name'));
    const creatableFieldGroups = fieldGroups ? (filterFamily && fieldGroups.get(filterFamily) || fieldGroups).map(fieldGroup => fieldGroup.update('properties', list => list.filter(isNameBlocklisted))) : undefined;
    const isValueDescriptionShown = isFieldDescriptionVisible && value && value.field;
    const valueDescription = isValueDescriptionShown ? getDescriptionString(value.field) : null;
    const valueUrl = value && getIn(['field', 'url'], value);
    const dataAttributes = Object.keys(rest).filter(key => key.startsWith('data-')).reduce((acc, key) => {
      acc[key] = rest[key];
      return acc;
    }, {});
    let currentPanel;
    if (this.isOnFamilySelect()) {
      currentPanel = `FilterFamilySelect`;
    } else if (this.isOnEntitySelect()) {
      currentPanel = `FilterFamilyEntitySelect`;
    } else if (this.isOnFieldSelect()) {
      currentPanel = `FilterEditorFieldSelect`;
    } else if (this.isOnOperatorSelect()) {
      currentPanel = `FilterOperatorRefinableInput`;
    }
    return /*#__PURE__*/_jsxs(FilterEditorPanel, Object.assign({
      "data-selenium-test": "XOFilterEditor-create-panel"
    }, dataAttributes, {
      className: className,
      description: valueDescription,
      editorSubtitle: editorSubtitle,
      getIsUngated: getIsUngated,
      handleGoBack: this.handleGoBack,
      isBackButtonDisabled: isInitialStepBackButtonDisabled && isInitialStep,
      isBodyHeightFixed: isBodyHeightFixed,
      isXoEnabled: isXoEnabled,
      onSubmit: value ? this.handleSubmit : null,
      renderFieldLink: renderFieldLink,
      saveLabel: labelOperatorCreateSave,
      style: style,
      title: this.getEditorTitle(),
      url: valueUrl,
      value: value,
      children: [currentPanel === `FilterFamilySelect` && /*#__PURE__*/_jsx(FilterFamilySelect, {
        activeGroup: activeGroup,
        getFilterFamilyName: getFilterFamilyName,
        onClick: this.handleSelectFilterFamily,
        options: filterFamilyOptions
      }), currentPanel === `FilterFamilyEntitySelect` && /*#__PURE__*/_jsx(FilterEditorEntitySelect, {
        FieldSelectItemComponent: FieldSelectItemComponent,
        activeFieldNames: activeFieldNames,
        fieldGroups: creatableFieldGroups,
        fields: fields,
        filterFamily: filterFamily,
        getFilterFamilyName: getFilterFamilyName,
        getIsUngated: getIsUngated,
        getLabelString: getLabelString,
        getOperators: getOperators,
        isXoEnabled: isXoEnabled,
        loadMoreFields: loadMoreFields,
        onChange: this.handleSelectEntity,
        onSearchChange: this.handleSearchChange,
        searchValue: searchValue,
        searchable: searchable,
        value: value
      }), currentPanel === `FilterEditorFieldSelect` && /*#__PURE__*/_jsx(FilterEditorFieldSelect, {
        FieldSelectItemComponent: FieldSelectItemComponent,
        activeFieldNames: activeFieldNames,
        fieldGroups: creatableFieldGroups,
        fields: fields,
        filterFamily: filterFamily,
        getFilterFamilyName: getFilterFamilyName,
        getIsUngated: getIsUngated,
        getLabelString: getLabelString,
        getOperators: getOperators,
        isXoEnabled: isXoEnabled,
        loadMoreFields: loadMoreFields,
        onChange: this.handleSelectField,
        onSearchChange: this.handleSearchChange,
        searchValue: searchValue,
        searchable: searchable,
        value: value
      }), currentPanel === `FilterOperatorRefinableInput` && /*#__PURE__*/_jsx(FilterOperatorRefinableInput, {
        currencyCode: currencyCode,
        error: error,
        filterFamily: filterFamily,
        getDefaultTimezone: getDefaultTimezone,
        getFamilyValueResolver: getFamilyValueResolver,
        getFilterFamilyObjectName: getFilterFamilyObjectName,
        getInputComponent: getInputComponent,
        getIsUngated: getIsUngated,
        getObjectPropertyLabel: getObjectPropertyLabel,
        getOperatorLabel: getOperatorLabel,
        getOperators: getOperators,
        getPlaceholder: getPlaceholder,
        getReferencedObjectType: getReferencedObjectType,
        getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
        isFiscalYearEnabled: isFiscalYearEnabled,
        isRollingDateOffsetInputEnabled: isRollingDateOffsetInputEnabled,
        isXoEnabled: isXoEnabled,
        nullIssueRelatedState: nullIssueRelatedState,
        onChange: this.handleChange,
        showIncludeUnknownValues: showIncludeUnknownValues,
        updateNullIssueRelatedState: updateNullIssueRelatedState,
        value: value
      })]
    }));
  }
}
FilterEditorOperatorCreate.defaultProps = {
  activeFieldNames: ImmutableSet(),
  getFilterFamilyHasEntities: always(false),
  getFilterFamilyOptions: () => OrderedSet(),
  onChangeFilterFamily: _ => _
};
FilterEditorOperatorCreate.propTypes = {
  FieldSelectItemComponent: PropTypes.func,
  activeFieldNames: setOf(PropTypes.string.isRequired).isRequired,
  activeGroup: FilterType.isRequired,
  className: PropTypes.string,
  currencyCode: PropTypes.string.isRequired,
  editorSubtitle: PropTypes.node,
  fieldGroups: mapOf(FilterFieldGroupType),
  fields: mapOf(FilterFieldType),
  filterFamily: PropTypes.string,
  getDefaultTimezone: PropTypes.func.isRequired,
  getDescriptionString: PropTypes.func.isRequired,
  getFamilyValueResolver: PropTypes.func.isRequired,
  getFilterFamilyHasEntities: PropTypes.func.isRequired,
  getFilterFamilyName: PropTypes.func.isRequired,
  getFilterFamilyObjectName: PropTypes.func.isRequired,
  getFilterFamilyOptions: PropTypes.func.isRequired,
  getInputComponent: PropTypes.func.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  getLabelString: PropTypes.func.isRequired,
  getObjectPropertyLabel: PropTypes.func.isRequired,
  getOperatorLabel: PropTypes.func.isRequired,
  getOperators: PropTypes.func.isRequired,
  getPlaceholder: PropTypes.func.isRequired,
  getReferencedObjectType: PropTypes.func.isRequired,
  getSpecialOptionsForReferenceType: PropTypes.func.isRequired,
  isFieldDescriptionVisible: PropTypes.bool.isRequired,
  isFiscalYearEnabled: PropTypes.bool.isRequired,
  isInitialStepBackButtonDisabled: PropTypes.bool,
  isRollingDateOffsetInputEnabled: PropTypes.bool.isRequired,
  isXoEnabled: PropTypes.bool,
  labelOperatorCreateSave: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  loadMoreFields: PropTypes.func,
  nullIssueRelatedState: NullRelatedState,
  onChange: PropTypes.func.isRequired,
  onChangeFilterFamily: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onFieldSearchChange: PropTypes.func.isRequired,
  onTempColumnAdd: PropTypes.func,
  renderFieldLink: PropTypes.func.isRequired,
  searchable: PropTypes.bool,
  showIncludeUnknownValues: PropTypes.bool.isRequired,
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  updateNullIssueRelatedState: PropTypes.func,
  validateOperator: PropTypes.func.isRequired,
  value: FilterOperatorType
};